// Espejo del vocabulario de bunkey.objects/utils/constants/RightsConstants.js.
// Valores persistidos en metadata.rightsStatus — no reescribir como literal.
export const RIGHTS_STATUS_UNASSIGNED = "unassigned";
// Decisión consciente de que ese archivo no necesita derechos. Se distingue de
// `unassigned`, que es "todavía nadie lo revisó". El valor persistido de este
// último NO se renombró a "pending": cambia sólo su etiqueta visible.
export const RIGHTS_STATUS_NOT_REQUIRED = "not_required";
export const RIGHTS_STATUS_ENABLED = "enabled";

// Estados derivados (rightsState), calculados en el backend — no se persisten.
export const RIGHTS_STATE_UNASSIGNED = "unassigned";
export const RIGHTS_STATE_NOT_REQUIRED = "not_required";
export const RIGHTS_STATE_VALID = "valid";
export const RIGHTS_STATE_EXPIRING = "expiring";
export const RIGHTS_STATE_EXPIRED = "expired";

// Mismo umbral que RightsConstants.BATCH_CONFIRMATION_THRESHOLD en
// bunkey.objects — a partir de acá el modal pide confirmación explícita.
export const RIGHTS_BATCH_CONFIRMATION_THRESHOLD = 100;

// Espejo de BATCH_SYNC_LIMIT en bunkey.objects. Por encima de esto el backend
// rechaza el lote con RightsBatchTooLarge; se usa acá sólo para poder explicar
// el motivo en pantalla, la validación real está del lado del servidor.
export const RIGHTS_BATCH_MAX = 25000;

// Un solo tipo de acción, compartido por los 6 reducers de listado
// (assetsRoot/LastUpload/Favorites/Explore/Shared/searcher): al editar los
// derechos de un asset desde el panel de detalle (CollectionMiddleViewAssetInfo,
// vía PUT /rights/assets/:object) el sello de la grilla (RightsSeal, que lee
// del mismo array `data` que el panel) quedaba con el estado viejo hasta
// recargar la página, porque nada patcheaba ese ítem en la lista. No reutiliza
// *_EDIT_SUCCESS (ese sí dispara un PUT propio a /objects/:id con otro payload)
// — este es un dispatch puro, sin red, con los datos que ya devolvió el PUT de
// derechos.
export const ASSET_RIGHTS_STATE_UPDATED = "ASSET_RIGHTS_STATE_UPDATED";

// Espejo de MODULE_DEFAULTS en bunkey.objects/utils/constants/RightsConstants.js.
//
// Con qué valor se lee un flag que TODAVÍA no está en el array `modules` de la
// cuenta, que es el caso de todo el parque: el seed da de alta los servicios
// pero no toca el `modules` de nadie.
//
// El backend ya resolvía esto con estos mismos defaults; el front usaba un
// `.some()` pelado, que da false cuando la clave falta. Para
// blockDownloadOnExpiredRights —que arranca ENCENDIDO porque el bloqueo ya
// existe en producción— eso significaba que el front dejaba compartir con
// descarga y el backend después la rechazaba.
export const MODULE_DEFAULTS = {
  useRights: false,
  blockDownloadOnExpiredRights: true
};

/** Lee un flag de cuenta respetando el default cuando la clave no está. */
export const isModuleActive = (modules, name) => {
  const found = (modules || []).find(module => module.name === name);
  return found ? !!found.activate : !!MODULE_DEFAULTS[name];
};

// Espejo de FILTER_TYPES en bunkey.objects. "document" agrupa PDF, INDD y
// PRPROJ: los dos últimos viven en la base como `other`, pero para el usuario
// son documentos y el backend los junta en la misma rama del filtro.
// KAN-51: "font" junta las tipografías guardadas como `font` y como `other`
// (woff2, dfont…); "document" incluye también los editables idml, sketch, fig,
// xd y afdesign.
export const FILTER_TYPES = ["image", "video", "audio", "document", "font"];

// Contrato que respalda el período de derechos (feedback de Ricardo, 2026-09-10).
// Espejo de LICENSE_FILE_* en bunkey.objects: el backend vuelve a validar los
// tres, acá se comprueban sólo para no hacerle subir 20 MB a alguien que va a
// terminar en un 400.
export const LICENSE_FILE_PREFIX = "contracts/";
export const LICENSE_FILE_EXTENSIONS = ["pdf", "doc", "docx", "jpg", "jpeg", "png"];
export const LICENSE_FILE_MAX_BYTES = 20 * 1024 * 1024;
